import { Controller } from '@hotwired/stimulus'

/**
 * Design Feedback Controller
 *
 * Handles thumbs up/down feedback for design preference learning.
 * Sends feedback to the server and updates UI to show submitted state.
 */
export default class extends Controller {
  static values = {
    websiteId: String,
    templatePack: String,
    trackingToken: String
  }

  static targets = ['successMessage']

  async submitFeedback(event) {
    const button = event.currentTarget
    const feedbackType = button.dataset.feedbackType

    // Visual feedback - highlight selected button
    this.highlightButton(button, feedbackType)

    try {
      const response = await fetch('/ajax/design_feedback', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': this.csrfToken
        },
        body: JSON.stringify({
          website_id: this.websiteIdValue,
          tracking_token: this.trackingTokenValue,
          feedback_type: feedbackType,
          template_pack: this.templatePackValue,
          element_type: 'design',
          element_value: 'overall',
          context: {
            page: window.location.pathname
          }
        })
      })

      if (response.ok) {
        this.showSuccessMessage()
      } else {
        console.error('Failed to submit feedback')
      }
    } catch (error) {
      console.error('Error submitting feedback:', error)
    }
  }

  highlightButton(button, _feedbackType) {
    // Remove active state from all buttons
    this.element.querySelectorAll('.design-feedback-btn').forEach((btn) => {
      btn.classList.remove('active')
    })

    // Add active state to clicked button
    button.classList.add('active')
  }

  showSuccessMessage() {
    if (this.hasSuccessMessageTarget) {
      this.successMessageTarget.classList.remove('hidden')

      // Hide after 3 seconds
      setTimeout(() => {
        this.successMessageTarget.classList.add('hidden')
      }, 3000)
    }
  }

  get csrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.content || ''
  }
}
